
export default {
  props: {
    fields: {
      type: Array,
      required: true
    }
  }
};
